import React, { useMemo } from "react";
import { Col, Row } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import ContentTabs from "@repoflow/components/content-tabs";
import { useSectionContext } from "@repoflow/components/section";
import { usePreview } from "@repoflow/components/preview";
import * as widgets from "widgets/register";
import { TemplateLink } from "../../../blog";
import * as ConfigRoute from "../../config";

// Hoisted, for the reason every editor screen gives: an inline config literal
// is a new object per render and the form rebuilds under it.
const FORM_CONFIG = {
  "/Page/Element/Type/BlogPost": {
    fields: ["slug"],
  },
};

// ONE PUBLISHED POST. `slug` is normally `{{params.slug}}` — the route's — and
// the Editor tab's params decide which post the preview shows, exactly as they
// decide what a served page's `{{params.x}}` means.
const Post = () => {
  const { schema, state, attributes } = useSectionContext();
  const preview = usePreview();
  const { values, setValues } = state;
  const config = values.config || {};

  return (
    <Row>
      <Col>
        <p className="text-muted">
          On a page whose route is <code>/blog/:slug</code>, leave the slug as{" "}
          <code>{"{{params.slug}}"}</code> and set a slug on the Editor tab to
          preview one post.
        </p>
        <Form
          schema={schema}
          target={{ $ref: "/Page/Element/Type/BlogPost" }}
          widgets={widgets}
          values={config}
          onChange={(mod) => {
            setValues({ ...values, config: mod });
            preview.refresh();
          }}
          config={FORM_CONFIG}
        />
        <TemplateLink siteId={attributes.siteId} kind="post" />
      </Col>
    </Row>
  );
};

export const Content = () => {
  const tabs = useMemo(
    () => [
      { label: "Post", content: <Post /> },
      { label: "Element", content: <ConfigRoute.Content /> },
    ],
    []
  );

  return <ContentTabs tabs={tabs} />;
};
